import script from "./ArticleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleModal.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleModal.vue?vue&type=style&index=0&id=28961924&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28961924"]])

export default __exports__